import { render, staticRenderFns } from "./Nps.vue?vue&type=template&id=2d4482e3&"
import script from "./Nps.vue?vue&type=script&lang=js&"
export * from "./Nps.vue?vue&type=script&lang=js&"
import style0 from "./Nps.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports